var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"nice-select-option",class:{
		'selected': _vm.selected,
	},attrs:{"type":"button","tabindex":""},on:{"click":function($event){return _vm.$emit('select', _vm.value)}}},[(_vm.icon)?_c('NiceIcon2',{staticClass:"ni_option--icon",attrs:{"icon":_vm.icon}}):_vm._e(),_c('span',{staticClass:"ni_option--caption"},[_vm._v(_vm._s(_vm.caption))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }